import { Component } from './index';

export class Address extends Component {
  verify(placeId: string) {
    return this.requester.get(`/address/verify?placeId=${placeId}`)
  }
}
